import { Configuration, AccountInfo } from '@azure/msal-browser';

export const environmentVars = {
  apiUrl: process.env.REACT_APP_API_URL_PROMPT,
  apiKey: process.env.REACT_APP_API_KEY,
  ipstackApiKey: process.env.REACT_APP_IPSTACK_API_KEY,
  apiUrlMessages: process.env.REACT_APP_API_URL_MESSAGES,
  apiUrlRegister: process.env.REACT_APP_API_URL_REGISTER,
  azureTenantId: process.env.REACT_APP_AZURE_TENANT_ID,
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  azureClientId: process.env.REACT_APP_AZURE_CLIENT_ID,
};

interface AuthState {
  account: AccountInfo | null;
  loading: boolean;
  error: string | null;
  initialized: boolean;
}

export const tokenRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email']
};

export const silentRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
  loginHint: ''  // Will be populated during login
};

export const msalConfig: Configuration = {
  auth: {
    clientId: environmentVars.azureClientId || '',
    authority: 'https://login.microsoftonline.com/consumers',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true, // Enable cookies for IE11 support
    secureCookies: true
  },
  system: {
    allowNativeBroker: false,
    loggerOptions: {
      logLevel: 3,
      piiLoggingEnabled: false
    },
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
    asyncPopups: false
  }
};

export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email']
};